import { Component, Injector, Input, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TenantServiceProxy } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { LocalStorageService } from '@shared/utils/local-storage.service';


@Component({
selector: 'deleteAccount',
templateUrl: './delete-account-modal.component.html',
styleUrls: ['./delete-account-modal.component.less']
})
export class DeleteAccountModalComponent extends AppComponentBase{
@Input() tenant: any;

@ViewChild('modal', { static: true }) modal: ModalDirective;
constructor(
    injector: Injector,
    private _tenantServiceProxy: TenantServiceProxy,
    private _localStorageService: LocalStorageService
  ) {
    super(injector);
}

show(): void {
    this.modal.show();
}
close(): void {
    this.modal.hide();
}

async delete() {
    try{
      await this._tenantServiceProxy.deleteOwnTenant().toPromise();
      this.notify.info(this.l('DeletedSuccessfully'));
      this.modal.hide();
    }catch(ex)
    {
      this.notify.info(this.l('DeletedSuccessfully'));
      this.modal.hide();
      this._localStorageService.clearAllStorageAndCookies();
      window.location.href = window.location.origin + '/account/login';
    }
  }
}
